import { useCallback, useEffect, useState } from 'react'

import { getAllSavedAddress } from '@src/quince-site-common/src/services/addressService/addressService'
import { Address } from '@src/quince-site-common/src/services/addressService/addressType'

const useAddress = () => {
  const [savedAddress, setSavedAddress] = useState<Address[]>([])
  const [defaultAddress, setDefaultAddress] = useState<Address | undefined>(undefined)

  const updateDefaultAddress = useCallback((data: Address[]) => {
    setDefaultAddress(data.find(address => address.isDefault))
  }, [])

  useEffect(() => {
    getAllSavedAddress()
      .then(data => {
        setSavedAddress(data)
        updateDefaultAddress(data)
      })
      .catch((e: unknown) => {
        console.error('Error while fetching saved address, getAllSavedAddress()::', e)
      })
  }, [updateDefaultAddress])

  const getRefreshedSavedAddress = useCallback(() => {
    getAllSavedAddress()
      .then(data => {
        setSavedAddress(data)
        updateDefaultAddress(data)
      })
      .catch((e: unknown) => {
        console.error(
          'Error while fetching saved address, getAllSavedAddress(), getRefreshedSavedAddress() runtime::',
          e,
        )
      })
  }, [updateDefaultAddress])

  return {
    defaultAddress,
    savedAddress,
    getRefreshedSavedAddress,
  }
}

export default useAddress
